<template>
  <div id="filter-result-showcase-app" :class="isMobile() ? 'mobile' : ''" @scroll="onScroll">
    <DashboardHeader :user="userData.user" :ads="userData.ads" :adsFormatted="userData.adsFormatted"
                     :purchasesLastMonth="userData.purchasesLastMonth" :pendingDebits="userData.debits"/>

    <v-container fluid class="campaigns-dashboard pa-[12px]" v-if="loading">
      <v-skeleton-loader
          v-for="n in 5"
          :key="n"
          type="heading, subtitle"
          style="background-color: transparent; margin-top: 40px"
          width="100%"
          max-width="500px"
      />
    </v-container>
    <v-container fluid class="campaigns-dashboard pa-[12px]" v-else>
      <div class="campaign" v-for="(obj, index) in listVeiculos" v-bind:key="index">
        <VehiclesSlider :vehicles="obj.vehicles" :key_showcase="obj.campaign"
                        :isMobile="isMobile()" :title="obj.carousel.title" :subtitle="obj.carousel.desc"
                        :icon="obj.carousel.icon"/>
      </div>
    </v-container>

    <HistoryChip :logs="userData.logs" style="padding-bottom: 100px" v-if="!loading"/>
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from "vuex";
import PlatformsMixins from "@/mixins/PlatformsMixins";
import VehiclesSlider from "./components/VehiclesSlider.vue";
import DashboardHeader from "./components/DashboardHeader.vue";
import HistoryChip from "@/views/showcase/components/HistoryChip.vue";
import {VSkeletonLoader} from "vuetify/components";

export default {
  name: "DashboardShowcase",
  components: {
    VSkeletonLoader,
    VehiclesSlider,
    DashboardHeader,
    HistoryChip
  },
  mixins: [PlatformsMixins],
  data() {
    return {
      showcaseKey: false,
      loading: true
    };
  },
  computed: {
    ...mapState({
      selectedPage: (state) => state.filterShowcase.page,
      totalPages: (state) => state.filterShowcase.total,
      params: (state) => state.filterShowcase.params,
      userData: (state) => state.filterShowcase.userData,
      carouselVehicles: (state) => state.filterShowcase.carousel,
      rawListVeiculos: state => state.filterForm.listVeiculos,
      vehicles: (state) => state.filterForm.result,
      ads: (state) => state.ads,
    }),
    listVeiculos() {
      if (!this.rawListVeiculos) return [];
      return Object.keys(this.rawListVeiculos).map(campaign => ({
        campaign,
        vehicles: this.rawListVeiculos[campaign].vehicles,
        carousel: this.rawListVeiculos[campaign].carousel
      }));
    }
  },
  methods: {
    ...mapActions("filterForm", ["pagination", "searchCampaignVehicles"]),
    ...mapActions("filterShowcase", ["getDashboardData"]),
    ...mapActions("filterForm", ["searchFilters"]),
    ...mapActions("ads", ["getCampaign"]),
    ...mapMutations("global", ["setCurrentMainMenu"]),
    async getCarouselVehicles() {
      const campaigns = Object.keys(this.carouselVehicles);

      campaigns.forEach(camp => {
        const carouselData = {
          ...this.carouselVehicles[camp]
        };
        this.$store.commit("filterForm/initCarousel", { campaign: camp, carousel: carouselData });
      });
      await this.searchCampaignVehicles(campaigns);
    }
  },
  mounted: async function () {
    this.setCurrentMainMenu({
      section: "showcase",
      breadcrumb: "Dashboard",
      breadcrumbMobile: ["Dashboard"],
      filter: false,
      order: false,
    });

    this.page = this.selectedPage;
    await this.getDashboardData();
    this.loading = false;

    await Promise.all([
        this.searchFilters(),
        this.getCarouselVehicles(),
    ])
  },
};
</script>

<style scoped lang="scss">
.scroll-loading {
  margin-top: 30px;
  margin-bottom: 100px;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 20px;
  flex-direction: column;
  text-align: center;
}

.scroll-loading span {
  font-family: "Lexend Deca";
  font-size: 20px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}

.scroll-loading p {
  font-family: "Lexend Deca";
  font-size: 18px;
  font-weight: bold;
  padding: 0 32%;
  text-align: center;
}

@media only screen and (max-width: 920px) {
  .scroll-loading p {
    padding: 0;
  }

  .scroll-loading span {
    font-size: 16px;
  }

  .scroll-loading p {
    font-size: 14px;
  }
}

.scroll-loading p a {
  color: #ff7a00;
}

.campaigns-dashboard.v-container {
  max-width: 100% !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
}

/* se houver v-row/v-col dentro, remova gutters/margens */
.campaigns-dashboard .v-row {
  margin-left: 12px !important;
  margin-right: 12px !important;
}
.campaigns-dashboard .v-col {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

#filter-result-showcase-app {
    padding-left: 12px !important;
    padding-right: 12px !important;
  &.mobile {
    .slider-vehicle {
      h2 {
        font-size: 1.2em;
      }

      .v-slide-group__prev,
      .v-slide-group__next,
      .v-slide-group__next--disabled {
        display: none !important;
        background-color: red;
        min-width: auto !important;
      }
    }
  }
}

.container-alert-text-vehicle {
  display: flex;
  justify-content: flex-start;
}

.card-skeleton {
  border: 7px solid #ffffff;
  border-radius: 12px;
}

.alert-text-vehicle {
  color: #868686;
  font-size: 18px;
  font-family: "Lexend Deca";
  font-weight: 400;
  word-wrap: break-word;
  width: 500px;
  line-height: 40px;
}

.sorry-text {
  color: #868686;
  font-size: 22px;
  font-family: "Lexend Deca";
  font-weight: 400;
  word-wrap: break-word;
}

.btn-alert-vehicle {
  color: white;
  font-size: 18px !important;
  font-family: "Lexend Deca";
  font-weight: 400;
  word-wrap: break-word;
  width: 260px !important;
  background-color: #ff7a00 !important;
}

#filter-result-showcase-app {
  flex: 78;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: scroll;
  height: v-bind(contentHeightWithButtonFooter);
}

.scroll-loading {
  margin-top: 40px;
  margin-bottom: 70px;
}


@media screen and (max-width: 768px) {
  #filter-result {
    position: relative;
  }

  .container-not-result {
    padding: 15px;
  }

  .not-result {
    min-height: 65vh !important;
  }
}

.not-result {
  position: relative;
  min-height: 70vh;
  display: flex;
  flex-direction: column;
}

.scroll-loading {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 20px;
  flex-direction: column;
  text-align: center;
}

.scroll-loading span {
  font-family: "Lexend Deca";
  font-size: 20px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}

.scroll-loading p {
  font-family: "Lexend Deca";
  font-size: 18px;
  font-weight: bold;
  padding: 0 32%;
  text-align: center;
}

@media only screen and (max-width: 920px) {
  .scroll-loading p {
    padding: 0;
  }

  .scroll-loading span {
    font-size: 16px;
  }

  .scroll-loading p {
    font-size: 14px;
  }
}

.scroll-loading p a {
  color: #ff7a00;
}

.campaigns-dashboard {
  .v-row {
    &:last-child {
      margin-bottom: 5em;
    }

    .slider-vehicle {
      .vehicle {}

      .vehicle-footer {
        display: none !important;
      }
    }
  }

  .campaign {
    &:last-child {
      padding-bottom: 8em;
    }
  }
}

h2.showcase-title {
  margin: 1em 0;
}
</style>
